/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import ProgressBar from 'components/shared/progressbar/progressbar';
import Question from 'components/content/shared/questionset/shared/question/question_container';
import Answer from 'components/content/shared/questionset/shared/answer/answer_container';
import Skip from 'components/shared/skip/skip_container';
// import QuestionResult from 'components/shared/questionset/shared/result/result_container';
// import RewardsMessage from 'components/shared/questionset/shared/rewards/rewards_container';
import UserMessage from 'components/shared/usermessage/usermessage';
import RewardsFeedback from 'components/shared/rewardsfeedback/rewardsfeedback_container';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/content/shared/questionset/text2/text2_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:true});


// return <Text2Answer id={this.props.answer.id} text={this.props.answer.text} predictionPercentage={this.props.predictionPercentage} barCoefficient={this.props.barCoefficient} isCorrect={this.props.answerStatus.isCorrect} isClicked={this.isSelected()} isResult={this.isResult()} />;

/* ========== ~~~~~~~~~~ TEXT 2 SET ~~~~~~~~~~ ========== */
const Text2Set = (passedProps) => {
    const props = passedProps.data;
    const resultClass = props.frameStatus[props.frame]['state'];
    // resultClass = props.frameStatus[props.frame].includes('rewards') ? 'rewards' : resultClass;
    sheet.update(props.hasRewardsComponent);
    return(
        <div className={`${sheet.classes.typeset} type-${props.frameData.question.type} parentContentType-${passedProps.contentType} answeramount-${props.frameData.answers.length} ${resultClass}`}>
            <div className={`${sheet.classes.resultelements} resultelements`}>
                {/*QuestionResult component handles logic related to calculating and awarding points / triggering or skipping the rewards phase and advancing the result phase*/}
                {/*<QuestionResult contentId={props.contentId} frame={props.frame} />*/}
                <ProgressBar type={`result`} duration={props.showResultForXSeconds} fillingDelay={2400} direction={`leftToRight`} isActive={resultClass === 'result'} shouldKillItself={false}/>
                <UserMessage hasRewardsComponent={passedProps.hasRewardsComponent}>
                    <RewardsFeedback contentId={passedProps.data.contentId} frame={props.frame} />
                </UserMessage>
            </div>
            {props.showFrameForXSeconds != null ? <ProgressBar type={`frame`} duration={props.showFrameForXSeconds} fillingDelay={0} direction={`leftToRight`} isActive={props.showFrameForXSeconds != null} shouldKillItself={resultClass === 'clicked'}/> : null}
            <Question contentId={props.contentId} frameData={props.frameData} />
            <div className={`${sheet.classes.answerset} answerset answeramount-${props.frameData.answers.length}`}>
                <ul>
                    {props.frameData.answers.map(answer => <Answer type={props.frameData.question.type} answer={answer} predictionPercentage={passedProps.percentageAnsweredData[answer.id]} barCoefficient={passedProps.barCoefficient} contentId={props.contentId} frame={props.frame} />)}
                </ul>
            </div>
            {/*<RewardsMessage contentId={passedProps.data.contentId} frame={props.frame} />*/}
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Text2Set;
